const SETTING_ACTIONS = {
  //get all status
  GET_ALL_STATUS: "GET_ALL_STATUS",
  GET_ALL_STATUS_SUCCESS: "GET_ALL_STATUS_SUCCESS",
  GET_ALL_STATUS_FAIL: "GET_ALL_STATUS_FAIL",
  //add status
  POST_STATUS: "POST_STATUS",
  POST_STATUS_SUCCESS: "POST_STATUS_SUCCESS",
  POST_STATUS_FAIL: "POST_STATUS_FAIL",
  //delete status
  DELETE_STATUS: "DELETE_STATUS",
  DELETE_STATUS_SUCCESS: "DELETE_STATUS_SUCCESS",
  DELETE_STATUS_FAIL: "DELETE_STATUS_FAIL",
  //get status by id
  GET_STATUS_BY_ID: "GET_STATUS_BY_ID",
  GET_STATUS_BY_ID_SUCCESS: "GET_STATUS_BY_ID_SUCCESS",
  GET_STATUS_BY_ID_FAIL: "GET_STATUS_BY_ID_FAIL",
  //edit status
  EDIT_STATUS: "EDIT_STATUS",
  EDIT_STATUS_SUCCESS: "EDIT_STATUS_SUCCESS",
  EDIT_STATUS_FAIL: "EDIT_STATUS_FAIL",
  //get organization
  GET_ALL_ORGANIZATION: "GET_ALL_ORGANIZATION",
  GET_ALL_ORGANIZATION_SUCCESS: "GET_ALL_ORGANIZATION_SUCCESS",
  GET_ALL_ORGANIZATION_FAIL: "GET_ALL_ORGANIZATION_FAIL",
  //post organization
  POST_NEW_ORGANIZATION: "POST_NEW_ORGANIZATION",
  POST_NEW_ORGANIZATION_SUCCESS: "POST_NEW_ORGANIZATION_SUCCESS",
  POST_NEW_ORGANIZATION_FAIL: "POST_NEW_ORGANIZATION_FAIL",
  //delete organization
  DELETE_ORGANIZATION: "DELETE_ORGANIZATION",
  DELETE_ORGANIZATION_SUCCESS: "DELETE_ORGANIZATION_SUCCESS",
  DELETE_ORGANIZATION_FAIL: "DELETE_ORGANIZATION_FAIL",
  //get holiday
  GET_ALL_HOLIDAY: "GET_ALL_HOLIDAY",
  GET_ALL_HOLIDAY_SUCCESS: "GET_ALL_HOLIDAY_SUCCESS",
  GET_ALL_HOLIDAY_FAIL: "GET_ALL_HOLIDAY_FAIL",
  //get overtime
  GET_SETTING_OVERTIME: "GET_SETTING_OVERTIME",
  GET_SETTING_OVERTIME_SUCCESS: "GET_SETTING_OVERTIME_SUCCESS",
  GET_SETTING_OVERTIME_FAIL: "GET_SETTING_OVERTIME_FAIL",
  //get commission setting
  GET_PAYROLL_COMMISSION_SETTING: "GET_PAYROLL_COMMISSION_SETTING",
  GET_PAYROLL_COMMISSION_SETTING_SUCCESS:
    "GET_PAYROLL_COMMISSION_SETTING_SUCCESS",
  GET_PAYROLL_COMMISSION_SETTING_FAIL: "GET_PAYROLL_COMMISSION_SETTING_FAIL",
  //get SETTING QRCODE
  GET_SETTING_QRCODE: "GET_SETTING_QRCODE",
  GET_SETTING_QRCODE_SUCCESS: "GET_SETTING_QRCODE_SUCCESS",
  GET_SETTING_QRCODE_FAIL: "GET_SETTING_QRCODE_FAIL",
  GET_SETTING_QRCODE_ROOM: "GET_SETTING_QRCODE_ROOM",
  GET_SETTING_QRCODE_ROOM_SUCCESS: "GET_SETTING_QRCODE_ROOM_SUCCESS",
  GET_SETTING_QRCODE_ROOM_FAIL: "GET_SETTING_QRCODE_ROOM_FAIL",
  UPDATE_SETTING_QRCODE_ROOM: "UPDATE_SETTING_QRCODE_ROOM",
  UPDATE_SETTING_QRCODE_ROOM_FAIL: "UPDATE_SETTING_QRCODE_ROOM_FAIL",
};
export default SETTING_ACTIONS;
